module.exports = __webpack_public_path__ + "img/bluetooth.465d4070.png";